import { forwardRef } from "react";

import { ButtonStyled, CircularProgressStyled } from "./Button.styled";

export const Button = forwardRef(
  (
    {
      children,
      disable = false,
      currentClass,
      small,
      styles,
      isLoading,
      ...rest
    },
    ref,
  ) => {
    return (
      <ButtonStyled
        disabled={disable}
        {...rest}
        ref={ref}
        variant="contained"
        small={small}
        addStyles={styles}
      >
        {children}
        {isLoading && <CircularProgressStyled size={24} />}
      </ButtonStyled>
    );
  },
);
